import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RmaApprovalModel, RmaCommentExModel, RmaCommentModel, RmaItemDetailModel, RmaItemModel, RmaItemSNModel, RmaMasterDetailModel, RmaMasterModel, RmaRequestModel } from 'src/app/shared/models/rma.model';
import { RmaMasterService } from 'src/app/shared/services/rma-master.service';
import {Location} from '@angular/common';
//import { ToastrService} from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user.service';
import { UserModel } from 'src/app/shared/models/user.model';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-rma-detail',
  templateUrl: './rma-detail.component.html',
  styleUrls: ['./rma-detail.component.css']
})
export class RmaDetailComponent implements OnInit {
  private sub: any;
  id: string;
  rmaMaster: RmaMasterDetailModel;
  rmaItems : RmaItemDetailModel[];
  isUnderWarranty : boolean;
  canProcceed : boolean;
  canClose : boolean;
  isLastProccess : boolean;
  isNextTestedProccess : boolean;
  users : UserModel[];
  rmaTypeList : string[];
  rmaStatusComments : RmaCommentExModel[];

  constructor(
    private userService : UserService,
    private route: ActivatedRoute,
    private service : RmaMasterService,
    private location: Location,
    //private toastr : ToastrService,
    private gnotify : GlobalNotification,
    private router : Router) {
      this.canProcceed = false;
      this.canClose = false;
     // this.rmaTypeList = GlobalConstants.constRmaTypeArray;
      this.rmaTypeList = null;
    }

  ngOnInit() {


    this.sub = this.route.params.subscribe(params => {
      // this.id = +params['id']; // (+) converts string 'id' to a number
       this.id = params['id'];

       console.log("id : " + this.id);

       if(this.id != null)
       {
        this.userService.getUserList().subscribe(
          res=>{
            this.users = res as UserModel [];
            this.loadData();
          },
          err=>{}
        );
       }
       // In a real app: dispatch action to load the details here.
    });
  }

  loadData(){
      this.service.getDetail(this.id).subscribe(
        res=>{
          this.rmaMaster = res as RmaMasterDetailModel;
          this.rmaMaster.comment = new RmaCommentModel(this.rmaMaster.rmaId, null, this.rmaMaster.status);
          this.rmaMaster.isStanby = GlobalConstants.isStandBy(this.rmaMaster.status);
          this.rmaMaster.isClosed = GlobalConstants.isClosed(this.rmaMaster.status);
          var nextStatus = this.getNextProcessStatus(this.rmaMaster.rmaType, this.rmaMaster.status);
          this.isLastProccess = GlobalConstants.isClosed(nextStatus);
          this.isNextTestedProccess = GlobalConstants.isTested(nextStatus);
          this.rmaMaster.createByUser = this.users.find(item => item.id === this.rmaMaster.createBy);

          if(GlobalConstants.isClientDealer(this.rmaMaster.clientType))
          {
            this.rmaTypeList = GlobalConstants.constRmaTypeArrayForDealer;
          }
          else
          {
            this.rmaTypeList = GlobalConstants.constRmaTypeArrayForClient;
          }
          this.loadItemData();

          if(!this.rmaMaster.isStanby)
          {
            this.loadCommentData(this.rmaMaster.rmaId);
          }
        },
        err=>{
          console.log("err : " + err.message);
          ////this.toastr.error("Cannot find the RMA detail", "RMA Detail");
          this.gnotify.showSnackBar('RMA Detail', 'Cannot find the RMA detail', "error");
          this.location.back();
        },
        ()=>{
          console.log("finalize");
          if(this.rmaMaster == null) this.location.back();
        }
      );

  }

  loadItemData(){
    this.canProcceed = false;
    this.canClose = false;

    this.service.getRmaItemList(this.rmaMaster.rmaId).subscribe(
      res=>{
        var alltag = true;
        var alldeclined = true;
        var alltested = true;

        this.rmaItems = res as RmaItemDetailModel[];
        for(var item of this.rmaItems)
        {
          this.loadItemSNData(item.rmaItemId);
          item.comment = new RmaCommentModel(item.rmaId, item.rmaItemId, item.status);
          item.warrantyString = (item.warranty? "1":"0");
          item.isStanby = GlobalConstants.isStandBy(item.status);
          item.isTested = GlobalConstants.isTested(item.status);
          if (!item.isStanby)
          {
            if(!item.declined)
            {
              alldeclined = false;
              if(!item.isTested) alltested = false;
            }

            this.loadItemCommentData(item.rmaId, item.rmaItemId);
          }
          else{
              item.commentList = null;
              alltag = false;
          }
        }

        this.canClose = (alldeclined && alltag) || this.isLastProccess;

        if(this.isNextTestedProccess)
        {
          this.canProcceed = alltested;
        }
        else{
          this.canProcceed = alltag;
        }

        console.log("isNextTestedProccess : " + this.isNextTestedProccess);
        console.log("All Tested : " + alltested);
        console.log("canProcceed : " + this.canProcceed);

      },
      err=>{
        console.log(err);
      }
    );
  }

  loadCommentData(rmaId)
  {
    this.service.getRmaCommentList(rmaId).subscribe(
      res=>{
        let array = res as RmaCommentModel[];
        this.rmaMaster.commentList = array.map(
          obj => {
            obj.createByUser = this.users.find(item => item.id === obj.createBy);
            return {...obj}
          }
        );
        this.rmaStatusComments = new Array<RmaCommentExModel>();
        var mainCommants = this.rmaMaster.commentList.filter(item => item.flag == false);
        mainCommants.forEach(element => {
          var item = new RmaCommentExModel(element);
          item.subcomments = this.rmaMaster.commentList.filter(item => item.status == element.status);

          this.rmaStatusComments.push(item);
        });

      },
      err=>{
        console.log(err);
      }
    );

  }

  loadItemSNData(rmaItemId)
  {
    this.service.getRmaItemSNList(rmaItemId).subscribe(
      res=>{
        const found = this.rmaItems.find(x => x.rmaItemId == rmaItemId);
        let array = res as RmaItemSNModel[];
        found.snList = array.map(x=>x.sn);
      },
      err=>{
        console.log(err);
      }
    );
  }


  loadItemCommentData(rmaId, rmaItemId)
  {

    console.log("loadItemCommentData");
    this.service.getRmaCommentList(rmaId, rmaItemId).subscribe(
      res=>{
        const found = this.rmaItems.find(x => x.rmaItemId == rmaItemId);
        let array = res as RmaCommentModel[];
        found.commentList = array.map(
          obj => {
            obj.createByUser = this.users.find(item => item.id === obj.createBy);
            return {...obj}
          }
        );

        found.commentStatusList = new Array<RmaCommentExModel>();
        var mainCommants = found.commentList.filter(item => item.flag == false);
        mainCommants.forEach(element => {
          var item = new RmaCommentExModel(element);
          item.subcomments = found.commentList.filter(item => item.status == element.status);

          found.commentStatusList.push(item);
        });

      },
      err=>{
        console.log(err);
      }
    );

  }

  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }

  getRmaTypeString(type)
  {
    return GlobalConstants.getRmaTypeString(type);
  }

  getStatusString(status)
  {
    return GlobalConstants.getStatusString(status);
  }

  getCustomerString(type)
  {
    return GlobalConstants.getCustomerString(type);
  }

  getStatusColor(status)
  {
    return GlobalConstants.getStatusColor(status);
  }

  getNextProcessStatus(type, status)
  {
    return GlobalConstants.getNextProcessStatus(type, status);
  }

  getNextProcessStatusString(type, status)
  {
    return GlobalConstants.getNextProcessStatusString(type, status);
  }

  onWarrantyChangeAction(data) {
    // var value = this.form.get('issueCategoryId').value;
     console.log("onWarrantyChangeAction : " + data.source.selected.viewValue);
     this.isUnderWarranty = (data.source.selected.value == "1");
    }

  onApprove(rmaItem){
    console.log("onApprove : " + rmaItem.rmaItemId);

    if(rmaItem.comment.comment == null)
    {
      ////this.toastr.error("Please fill out all the items.", "RMA Request Procced");
      this.gnotify.showSnackBar('RMA Request Procced', 'Please fill out all the items.', "error");
      return;
    }

    var item = RmaItemDetailModel.convertToRmaItemWithComment(rmaItem);
    this.service.approveItem(item).subscribe(
      res=>{
         ////this.toastr.success("Submit successfuly", "RMA Request");
         this.gnotify.showSnackBar('RMA Request', 'Submit successfuly', "success");
         this.loadItemData();
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "RMA Request");
        this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
        return;
      }
    );
  }

  onDecline(rmaItem){
    console.log("onDecline : " + rmaItem.rmaItemId);

    if(rmaItem.comment.comment == null)
    {
      ////this.toastr.error("Please fill out all the items.", "RMA Request Procced");
      this.gnotify.showSnackBar('RMA Request Procced', 'Please fill out all the items.', "error");
      return;
    }

    var item = RmaItemDetailModel.convertToRmaItemWithComment(rmaItem);
    this.service.declineItem(item).subscribe(
      res=>{
         ////this.toastr.success("Submit successfuly", "RMA Request");
         this.gnotify.showSnackBar('RMA Request', 'Submit successfuly', "success");
         this.loadItemData();
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "RMA Request");
        this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
        return;
      }
    );
  }

  onTest(rmaItem){
    console.log("onTest : " + rmaItem.rmaItemId);

    if(rmaItem.comment.comment == null)
    {
      ////this.toastr.error("Please fill out all the items.", "RMA Request Procced");
      this.gnotify.showSnackBar('RMA Request Procced', 'Please fill out all the items.', "error");
      return;
    }

    var item = RmaItemDetailModel.convertToRmaItemWithComment(rmaItem);
    this.service.testItem(item).subscribe(
      res=>{
         ////this.toastr.success("Submit successfuly", "RMA Request");
         this.gnotify.showSnackBar('RMA Request', 'Submit successfuly', "success");
         this.loadItemData();
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "RMA Request");
        this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
        return;
      }
    );
  }

  OnCommentEdit(item)
  {
      item.commentSaved = item.comment;
      item.isEditMode = true;

  }

  OnCommentEditCancel(item)
  {
    item.comment = item.commentSaved;
    item.isEditMode = false;
  }

  OnCommentEditSave(item)
  {
    if(item.comment == null || item.comment.length == 0)
    {
      this.gnotify.showSnackBar('Comment Modify', 'Please type the comment.', "warning");
      return;
    }

    this.service.updateComment(item).subscribe(
      res=>{
        ////this.toastr.success("Submit successfuly", "Comment Modify");
        this.gnotify.showSnackBar('Comment Modify', 'Submit successfuly', "success");
        item.isEditMode = false;
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "Comment Modify");
        this.gnotify.showSnackBar('Comment Modify', 'Failed to Submit', "error");
      }
    );
  }

  OnCommentEditDelete(pitem, item)
  {
    if(!confirm("Are you sure to delete this comment?")) return;


    this.service.deleteComment(item.commentId).subscribe(
      res=>{
        ////this.toastr.success("Submit successfuly", "Comment Modify");
        this.gnotify.showSnackBar('Comment Delete', 'Submit successfuly', "warning");
        item.isEditMode = false;
        pitem.subcomments = pitem.subcomments.filter(x => x.commentId != item.commentId);
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "Comment Modify");
        this.gnotify.showSnackBar('Comment Delete', 'Failed to Submit', "error");
      }
    );

  }

  OnCommentAppend(item)
  {
    item.isEditMode = true;
  }

  OnCommentAppendCancel(item)
  {
    item.isEditMode = false;
  }

  OnCommentAppendSave(item, comment)
  {
    if(comment == null || comment.length == 0)
    {
      this.gnotify.showSnackBar('Comment Append', 'Please type the comment.', "warning");
      return;
    }
    console.log("OnCommentAppendSave");
    var newitem = new RmaCommentModel(item.rmaId, item.rmaItemId, item.status);
    newitem.comment = comment;
    newitem.flag = true;

    this.service.appendComment(newitem).subscribe(
      res=>{
        ////this.toastr.success("Submit successfuly", "Comment Modify");
        this.gnotify.showSnackBar('Comment Append', 'Submit successfuly', "success");
        item.isEditMode = false;
        newitem = res as RmaCommentModel;
        newitem.createByUser = this.users.find(item => item.id === newitem.createBy)

        item.subcomments.push(newitem);
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "Comment Modify");
        this.gnotify.showSnackBar('Comment Append', 'Failed to Submit', "error");
      }
    );
  }

  onCloseRequest()
  {
    if(!confirm("Are you sure to close this request?")) return;
    this.closeRequest();
  }

  closeRequest()
  {
    this.service.closeRmaRequest(this.rmaMaster).subscribe(
      res=>{
         ////this.toastr.success("Submit successfuly", "RMA Request Closed");
         this.gnotify.showSnackBar('RMA Request Closed', 'Submit successfuly', "success");
         this.router.navigateByUrl('/rma-list/close');
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Failed to Submit", "RMA Request");
        this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
        return;
      }
    );
  }

  onProceed()
  {
      console.log("onProceed");

      if(this.rmaMaster.rmaType == null || this.rmaMaster.comment.comment == null)
      {
        ////this.toastr.error("Please fill out all the items.", "RMA Request Procced");
        this.gnotify.showSnackBar('RMA Request Procced', 'Please fill out all the items.', "error");
        return;
      }
      var saveData = this.rmaMaster;
      saveData.status = this.getNextProcessStatus(this.rmaMaster.rmaType, this.rmaMaster.status)


      this.service.processRmaRequest(saveData).subscribe(
        res=>{
            ////this.toastr.success("Submit successfuly", "RMA Request Procced");
            this.gnotify.showSnackBar('RMA Request Procced', 'Submit successfuly', "success");

            if(GlobalConstants.isApproved(saveData.status) && saveData.emailRequested)
            {
              var result = res as RmaMasterModel;
              var tmp = new RmaApprovalModel();
              tmp.clientName = saveData.clientName;
              tmp.clientEmail = saveData.clientEmail1;
              tmp.rmaCode = result.rmaCode;
              tmp.comment = saveData.comment.comment;
              tmp.RmaItems = this.rmaItems;

              this.service.sendRMAApprovalNotification(tmp).subscribe(
                res=>{
                   ////this.toastr.success("Send email successfuly", "RMA Request Procced");
                   this.gnotify.showSnackBar('RMA Request Procced', 'Send email successfuly', "success");
                  },
                err=>{
                  console.log(err);
                  ////this.toastr.error("Failed to send email", "RMA Request Procced");
                  this.gnotify.showSnackBar('RMA Request Procced', 'Failed to send email', "error");
                  return;
                },
                ()=>{
                  console.log("finalize");
                  this.router.navigateByUrl('/rma-list/inprogress');
                }
              );
            }
            else{
                if(GlobalConstants.isClosed(this.getNextProcessStatus(this.rmaMaster.rmaType, saveData.status)))
                {
                  if(!confirm("Do you want to close this request?")) return;
                  this.closeRequest();
                }
                else{
                  this.router.navigateByUrl('/rma-list/inprogress');
                }
            }
        },
        err=>{
          console.log(err);
          ////this.toastr.error("Failed to Submit", "RMA Request");
          this.gnotify.showSnackBar('RMA Request', 'Failed to Submit', "error");
          return;
        }
      );
  }
}
